import { ArrowDownRight, ArrowUpRight, Loader2, Minus } from "lucide-react";
import { trpc } from "@/lib/trpc";
import { reais } from "@/lib/dinheiro";
import { cn } from "@/lib/cn";

/** O mês da organização comparado ao anterior: o número, a seta e a diferença. */
export function IndicadoresDoMes({ organizationId }: { organizationId: string }) {
  const consulta = trpc.painelDasOrganizacoes.detalhe.useQuery({ organizationId });
  if (consulta.isLoading) {
    return (
      <div className="flex justify-center py-8">
        <Loader2 className="h-5 w-5 animate-spin text-zinc-400" />
      </div>
    );
  }
  const lista = consulta.data ?? [];
  if (!lista.length) return <p className="py-4 text-sm text-zinc-500 dark:text-muted-foreground">Seu papel nesta organização não mostra números do mês.</p>;

  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 xl:grid-cols-6">
      {lista.map((i) => {
        const dif = i.atual - i.anterior;
        const Seta = dif > 0 ? ArrowUpRight : dif < 0 ? ArrowDownRight : Minus;
        const fmt = (v: number) => (i.formato === "reais" ? reais(v) : String(v));
        return (
          <div key={i.chave} className="min-w-0 rounded-xl border border-zinc-200 bg-white p-3 dark:border-border dark:bg-card">
            <p className="truncate text-[11px] font-medium text-zinc-500 dark:text-muted-foreground">{i.rotulo}</p>
            <p className="mt-1 truncate text-xl font-bold tabular-nums text-zinc-900 dark:text-foreground">{fmt(i.atual)}</p>
            {i.chave !== "equipe" && (
              <p className={cn("mt-0.5 flex items-center gap-1 text-[11px] tabular-nums", dif > 0 ? "text-emerald-600" : dif < 0 ? "text-red-600" : "text-zinc-500")}>
                <Seta className="h-3 w-3 shrink-0" />
                <span className="truncate">
                  {dif === 0 ? "igual ao" : `${dif > 0 ? "+" : "−"}${fmt(Math.abs(dif))} que o`} mês passado
                </span>
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}
